/** @module Specification/CareAndComposition/CompositionStringRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/StringTextarea"
], function(declare,StringRen) {
	return declare(StringRen, {
		/**
		 * Render the first value for attribute in HTML 
		 * module used to convert saved composition strings to html with line breaks
		 * @param {Context} ctx
		 * @param {Heading} h
		 * @param {DOMNode} refNode
		 * @param {ActionData} actionData
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			ctx.keyValue = 0;
			return this.inherited(arguments);
		}
	});
});